import axios from 'axios';
import { instance } from './api';

export async function getLocationList(payloads) {
  const { results, page, filters } = payloads;

  const applyFilter = filters?.length > 0 ? '&filter=' + filters : '';

  const response = await instance.get(
    `admin/getAllLocations?limit=${results}&page=${page}${applyFilter}`,
  );
  return response.data;
}


export async function getLocations(payload) {
  const { filter } = payload ?? {};
  let applyFilter = filter ? `?filter=${filter}` : '';
  // console.log('FILTER', applyFilter);
  const response = await instance.get(`admin/getAllLocations${applyFilter}`);
  return response.data;
}

export async function getLocationDetails(searchParams) {
  const response = await instance.get(`admin/getAllLocations/${searchParams}`);
  return response.data;
}

export async function getActiveLocationDetails(payload) {
  const { id, currentPage, pageSize } = payload;

  const response = await instance.get(
    `user/locations?limit=${pageSize}&page=${currentPage}`,
  );
  return response.data;
}

export async function getElevationData(values) {
  const latitude = values[0];
  const longitude = values[1];
  try {
    const response = await axios.get(
      `https://api.open-elevation.com/api/v1/lookup?locations=${latitude},${longitude}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function addLocation(payload) {
  const form = new FormData();
  form.append('Loc_Name', payload.Loc_Name);
  form.append('Loc_Total_Area', payload.Loc_Total_Area);
  form.append('Loc_Type', payload.Loc_Type);
  form.append('Type_of_land', payload.Type_of_land);
  form.append('Latitude', payload.Latitude);
  form.append('Longitude', payload.Longitude);
  form.append('Altitude', payload.Altitude);
  form.append('Location', payload.Location);
  form.append('Total_Ploting_Count', payload.Total_Ploting_Count);

  const response = await instance.post('admin/addLocation', form);
  return response.data;
}

export async function updateLocation(payload) {
  const form = new FormData();
  form.append('Loc_Name', payload.Loc_Name);
  form.append('Loc_Total_Area', payload.Loc_Total_Area);
  form.append('Loc_Type', payload.Loc_Type);
  form.append('Type_of_land', payload.Type_of_land);
  form.append('Latitude', payload.Latitude);
  form.append('Longitude', payload.Longitude);
  form.append('Is_Active', payload.Is_Active);
  form.append('Altitude', payload.Altitude);
  form.append('Location', payload.Location);
  form.append('Total_Ploting_Count', payload.Total_Ploting_Count);

  const response = await instance.post(`admin/updateLocation/${payload.params}`, form);
  return response;
}
// import api from "./api";
class LocationService {
  fetchLocation(payload) {
    if (payload) {
      return instance.get(`admin/getAllLocations/` + payload).then((res) => res.data);
    } else {
      return instance.get(`admin/getAllLocations`).then((res) => res.data);
    }
  }

  async addNewLocationData(payload) {
    const form = new FormData();
    form.append('Loc_Name', payload.Loc_Name);
    form.append('Loc_Total_Area', payload.Loc_Total_Area);
    form.append('Loc_Type', payload.Loc_Type);
    form.append('Type_of_land', payload.Type_of_land);
    form.append('Latitude', payload.Latitude);
    form.append('Longitude', payload.Longitude);
    form.append('Altitude', payload.Altitude);
    form.append('Total_Ploting_Count', payload.Total_Ploting_Count);

    const response = await instance.post('admin/addLocation', form);
    return response;
  }

  async updateNewLocationData(payload) {
    const form = new FormData();
    form.append('Loc_Name', payload.values.Loc_Name);
    form.append('Loc_Total_Area', payload.values.Loc_Total_Area);
    form.append('Loc_Type', payload.values.Loc_Type);
    form.append('Type_of_land', payload.values.Type_of_land);
    form.append('Latitude', payload.values.Latitude);
    form.append('Longitude', payload.values.Longitude);
    form.append('Is_Active', payload.values.Is_Active);
    form.append('Altitude', payload.values.Altitude);
    form.append('Total_Ploting_Count', payload.values.Total_Ploting_Count);

    const response = await instance.post(
      `admin/updateLocation/${payload.values.idLs}`,
      form,
    );
    return response;
  }
}

export default new LocationService();
